import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-winners-podium',
  templateUrl: './winners-podium.component.html',
  styleUrls: ['./winners-podium.component.scss']
})
export class WinnersPodiumComponent {

  @Input() myScore: number;
  @Input() firstPlaceScore: number;
  @Input() secondPlaceScore: number;
  @Input() thirdPlaceScore: number;

  constructor() {
    // No dependencies to inject
  }

}

